import { render, staticRenderFns } from "./FragmentMDHeading.vue?vue&type=template&id=aacf4e5c"
import script from "./FragmentMDHeading.vue?vue&type=script&lang=ts"
export * from "./FragmentMDHeading.vue?vue&type=script&lang=ts"
import style0 from "./FragmentMDHeading.vue?vue&type=style&index=0&id=aacf4e5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports